"use client";
const bilholdLightThemeClass = "theme-bilhold";
const brandlessThemeClass = "theme-brandless";
const gumpenThemeClass = "theme-gumpen";
const mollerBilThemeClass = "theme-moller-bil";
const nyeMollerBilThemeClass = "theme-nye-moller-bil";
const skodaDarkThemeClass = "theme-skoda";
const volkswagenThemeClass = "theme-volkswagen";
const dahlesThemeClass = "theme-dahles";
const autoriaThemeClass = "theme-autoria";
const audiThemeClass = "theme-audi";
const cupraThemeClass = "theme-cupra";
export {
  audiThemeClass,
  autoriaThemeClass,
  bilholdLightThemeClass,
  brandlessThemeClass,
  cupraThemeClass,
  dahlesThemeClass,
  gumpenThemeClass,
  mollerBilThemeClass,
  nyeMollerBilThemeClass,
  skodaDarkThemeClass,
  volkswagenThemeClass
};
